import {useState} from 'react';

import {arNum, STATUS_COLOR} from '../format';
import {isVideoAsset, useStudio} from '../store';
import type {Scene} from '../types';

/** A thumbnail that steps aside when it cannot load, leaving the scene number visible. */
function Thumb({scene, url}: {scene: Scene; url: string}) {
  const [broken, setBroken] = useState(false);
  if (!url || broken) return null;
  return isVideoAsset(scene.visual) ? (
    <video src={url} muted playsInline preload="metadata" onError={() => setBroken(true)} />
  ) : (
    <img src={url} alt="" onError={() => setBroken(true)} />
  );
}

export function SceneStrip({scenes}: {scenes: Scene[]}) {
  const s = useStudio();
  const total = scenes.reduce((sum, sc) => sum + sc.duration_s, 0);

  return (
    <div className="strip">
      <div className="shell">
        <div style={{display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10}}>
          <span className="h-title">شريط المشاهد</span>
          <span className="rule-line" />
          <span className="h-note">
            {scenes.length
              ? `${arNum(scenes.length)} مشاهد · ${arNum(Math.round(total))} ثانية`
              : 'لا توجد مشاهد بعد'}
          </span>
        </div>
        <div className="strip-scroll">
          {scenes.length === 0 ? (
            <span className="empty-note">سيظهر شريط المشاهد بعد تفكيك الموجز.</span>
          ) : (
            scenes.map((scene) => {
              const view = s.sceneView(scene);
              const meta =
                view.visual === 'busy'
                  ? 'جاري التوليد'
                  : view.visual === 'fail'
                    ? 'فشل · أعد المحاولة'
                    : view.visual === 'empty'
                      ? 'بلا مشهد مرئي'
                      : `${arNum(Math.round(scene.duration_s))} ثانية`;
              return (
                <button
                  type="button"
                  className="strip-item"
                  key={scene.id}
                  onClick={() => s.focusScene(scene.id)}
                >
                  <div
                    className={`ring ${view.visual}${s.focusedScene === scene.id ? ' on' : ''}`}
                  >
                    <div>
                      <div className={`thumb${view.visual === 'empty' ? ' empty' : ''}`}>
                        {arNum(scene.order)}
                        <Thumb scene={scene} url={view.visual === 'ready' ? view.visualUrl : ''} />
                      </div>
                    </div>
                  </div>
                  <div className="strip-name">مشهد {arNum(scene.order)}</div>
                  <div className="strip-meta" style={{color: STATUS_COLOR[view.status]}}>
                    {meta}
                  </div>
                </button>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}
